import { useTranslation } from 'react-i18next';
import { resources } from '../../../../../resources/resources';
import { FileInportTabTypes } from '../types';

interface FileInportTabNavProps {
  activeTab: FileInportTabTypes;
  onTabChange: (tab: FileInportTabTypes) => void;
}

export default function FileInportTabNav(
  props: Readonly<FileInportTabNavProps>,
) {
  const { activeTab, onTabChange } = props;
  const { t: translate } = useTranslation();
  return (
    <ul className="acc-tabs">
      <li
        onClick={() => onTabChange(FileInportTabTypes.EmployeeFileTab)}
        className={
          activeTab === FileInportTabTypes.EmployeeFileTab
            ? 'acc-tab-active'
            : undefined
        }
      >
        {translate(resources.admin.fileImport.employeeTab.title)}
      </li>
      <li
        onClick={() => onTabChange(FileInportTabTypes.TransactionFileTab)}
        className={
          activeTab === FileInportTabTypes.TransactionFileTab
            ? 'acc-tab-active'
            : undefined
        }
      >
        {translate(resources.admin.fileImport.budgetTab.title)}
      </li>
    </ul>
  );
}
